import m from "mithril";

import { Snowflakes } from "./components/snowflakes";

import { Layout } from "./page/layout";
import { HomePage } from "./page/home";
import { YearPage } from "./page/year";
import { DayPage } from "./page/day";

document.addEventListener("DOMContentLoaded", () => {
  m.mount(
    document.querySelector("#snowflakes") as HTMLElement,
    Snowflakes
  );
  m.route(
    document.querySelector("#app") as HTMLElement,
    "/",
    {
      "/": {
        render: () => <Layout><HomePage /></Layout>,
      },
      "/year/:year": {
        render: (vnode) => <Layout><YearPage year={vnode.attrs.year} /></Layout>,
      },
        "/year/:year/12/:day": {
        render: (vnode) => <Layout><DayPage year={vnode.attrs.year} day={vnode.attrs.day} /></Layout>,
      },
    }
  );
});
